/*****************************************************************************/
/*  File Name: tipCountHeader.js                                             */
/*  Date:      June 28, 2023                                                 */
/*  Author:    Christopher Cressman                                          */
/*  Purpose:   This bar is a basic title bar that will also have the tip
/*             count in it and the time range
/*
/*****************************************************************************/

import React from 'react';
import { withTranslation } from 'react-i18next';

//import styles from './styles/roi.module.scss';
import { Grid } from '@mui/material';
import { useROIContext } from '../../context/roiContext';
import * as TIMERANGE from '../../constants/timeRanges';
import styles from './styles/roi.module.scss';

function UpgradeTipCountHeader({ t }) {
  //Load all of the default component varaibles


  const { selectedTimeRange, roiUpgradeTipCount } = useROIContext();

  return (
    <Grid item xs={12} container alignItems='flex-end' className={`${styles.tipCountHeader} ${styles.upgradeGroupHeader}`}>
      <Grid item xs={12} className={styles.upgradeHeader}>
        Potential Cumulative Upgraded Profit Based on {roiUpgradeTipCount} {roiUpgradeTipCount === 1 ? 'Treatment' : 'Treatments'} Per {selectedTimeRange === TIMERANGE.weekly ? 'Week' : 'Month'}
      </Grid>
    </Grid>
  );
}

export default withTranslation()(UpgradeTipCountHeader);
